import { IconButton, InputAdornment } from "@mui/material"
import { ReactElement, useState } from "react"
import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"


export const useRevealPass = (): {
  showPass: boolean;
  endAdornment: ReactElement;
} => {
  const [showPass, setShowPass] = useState(false)

  const endAdornment = 
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onMouseDown={(e) => {
          e.preventDefault()
          setShowPass(true)
        }}
        onMouseUp={(e) => {
          e.preventDefault()
          setShowPass(false)
        }}
        onMouseLeave={(e) => {
          e.preventDefault()
          setShowPass(false)
        }}
        edge="end"
      >
        {showPass ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  return { showPass, endAdornment }
}
